import { authHeader } from '../_helpers';

const baseDomain = process.env.REACT_APP_DATA_SUBDOMAIN + "." + process.env.REACT_APP_DOMAIN;

export const pickService = {
    getTodaysPicks,
		getAllPicks
};

function getAllPicks(token, sport) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token)
    };

    return fetch('https://' + baseDomain  + '/picks/' + sport, requestOptions).then(handleResponse);
}

function getTodaysPicks(token, sport) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token)
    };
		let sinceTime = new Date(new Date().setHours(0,0,0,0)).getUnixTime();
    return fetch('https://'+ baseDomain + '/picks/' + sport+'?since='+sinceTime, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) { 
        return Promise.reject(response.statusText);
    }

    return response.json();
}



// WEBPACK FOOTER //
// ./src/_services/picks.js